import { render, staticRenderFns } from "./CrewPagination.vue?vue&type=template&id=4fb1c322"
import script from "./CrewPagination.vue?vue&type=script&lang=js"
export * from "./CrewPagination.vue?vue&type=script&lang=js"
import style0 from "./CrewPagination.vue?vue&type=style&index=0&id=4fb1c322&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports